import React from "react";

import { createSnackbar } from "utils/createSnackbar";

import instance from "api/v1";
import { useAuth } from "hooks/useAuth";

export function useDeleteBasesMeta() {
  // @ts-ignore
  const { user } = useAuth();
  const apiInstance = instance(user);

  return React.useCallback(
    (basesMetaId: number, basesMeta: [], setBasesMeta: any) => {
      const fetch = async () => {
        await apiInstance
          .delete(`/general-pages/${basesMetaId}`)
          .then(() => {
            createSnackbar("Bases meta tags deleted successfully");
            setBasesMeta(basesMeta.filter((item: any) => item.id !== basesMetaId));
          })
          .catch((error) => {
            console.error(error);
            if (error.response) createSnackbar(error.response.data.message);
            else createSnackbar("Something went wrong");
          });
      };
      fetch();
    },
    [],
  );
}
